module.exports = __webpack_public_path__ + "media/images/icons/resource-8139f2a77bf4fbeea504ef853167acb1.svg";